import { SET_MAP_AND_VIEW } from './actionTypes'

export const setMapAndView = (map, view) => ({
  type: SET_MAP_AND_VIEW,
  map,
  view,
})
